import React from 'react'
import { createMuiTheme } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import {
    CONTRAST_TEXT_FOR_PRIMARY_COLOR,
    CONTRAST_TEXT_FOR_SECONDARY_COLOR,
    MAIN_PRIMARY_COLOR,
    MAIN_SECONDARY_COLOR
} from 'src/common/razzle-platform-components/configs'

const isClient = typeof window !== 'undefined'

declare global {
	interface Window {
        nextPlatformMapMainPrimaryColor: string
        nextPlatformMapContrastTextForPrimaryColor: string
        nextPlatformMapMainSecondaryColor: string
        nextPlatformMapContrastTextForSecondaryColor: string
	}
}


const theme = createMuiTheme({
    palette: {
        primary: {
            main: isClient && window.nextPlatformMapMainPrimaryColor ? window.nextPlatformMapMainPrimaryColor : MAIN_PRIMARY_COLOR,
            contrastText: isClient && window.nextPlatformMapContrastTextForPrimaryColor ? window.nextPlatformMapContrastTextForPrimaryColor : CONTRAST_TEXT_FOR_PRIMARY_COLOR,
        },
        secondary: {
            main: isClient && window.nextPlatformMapMainSecondaryColor ? window.nextPlatformMapMainSecondaryColor : MAIN_SECONDARY_COLOR,
            contrastText: isClient && window.nextPlatformMapContrastTextForSecondaryColor ? window.nextPlatformMapContrastTextForSecondaryColor : CONTRAST_TEXT_FOR_SECONDARY_COLOR,
        }
    }
})


export default function MaterialThemeProvider(props) {

    React.useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
          jssStyles.parentElement.removeChild(jssStyles);
        }
        // we import styles in this platce for avoid the problem when build the app
    }, []);

    return(
        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>
    )
}
